const FIELD_VARIABLE_PREFIX = 'field_';

// Only field ids are checked: other variables are legitimately missing from the list for some billing models.
export function isStaleFieldVariableId(id, variables) {
  if (!variables?.length || typeof id !== 'string' || !id.startsWith(FIELD_VARIABLE_PREFIX)) {
    return false;
  }
  return !variables.some(variable => variable.id === id);
}

export function findStaleFieldVariableIds(nodes, variables) {
  const stale = new Set();
  if (!variables?.length || !Array.isArray(nodes)) return [];

  const visit = node => {
    if (!node || typeof node !== 'object') return;
    const id =
      node.type === 'variable'
        ? node.data?.id
        : node.type === 'condition'
          ? node.data?.variable?.id
          : undefined;
    if (isStaleFieldVariableId(id, variables)) stale.add(id);
    if (Array.isArray(node.children)) node.children.forEach(visit);
  };

  nodes.forEach(visit);
  return [...stale];
}
